export const DEFAULT_TEMPLATE_REPOSITORY = "template";